export default class ArrayPool {
  constructor(maxSize = 100) {
    /** @type {Array<any>} */
    this.pool = [];
    this.maxSize = maxSize;
  }

  acquire() {
    return this.pool.length > 0 ? this.pool.pop() : [];
  }

  /**
   *
   * @param {Array<any>} arr
   */
  release(arr) {
    if (this.pool.length < this.maxSize) {
      arr.length = 0;
      this.pool.push(arr);
    }
  }
}
